import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["id", "style", "className", "children", "visible", "searchable", "searchPlaceholder", "onSearch", "showSelectAll", "selectedAllChecked", "selectedAllDisabled", "multiple", "labelKey", "valueKey", "childrenKey", "itemTemplate", "badgeTemplate", "prefixTemplate", "suffixTemplate", "groupTemplate", "noResultFound", "maxHeight", "searchWord", "dropdownItemArialabel", "role", "searchRef", "dropdownRender"];
// @ts-nocheck
import React, { useCallback, useRef } from "react";
import ClassNames from "classnames";
import { KEY_VALUES, mergeRefs } from '../utils';
import Search from './Search';
import DropdownMenuItem from "./DropdownMenuItem";
import OptionListContext from "./OptionListContext";
import { getText } from "./utils";
var SELECT_ALL_KEY = "appkit4-select-all-key";
var DropdownMenu = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var id = props.id,
    style = props.style,
    className = props.className,
    children = props.children,
    _props$visible = props.visible,
    visible = _props$visible === void 0 ? false : _props$visible,
    searchable = props.searchable,
    searchPlaceholder = props.searchPlaceholder,
    onSearch = props.onSearch,
    _props$showSelectAll = props.showSelectAll,
    showSelectAll = _props$showSelectAll === void 0 ? false : _props$showSelectAll,
    selectedAllChecked = props.selectedAllChecked,
    selectedAllDisabled = props.selectedAllDisabled,
    multiple = props.multiple,
    _props$labelKey = props.labelKey,
    labelKey = _props$labelKey === void 0 ? 'label' : _props$labelKey,
    _props$valueKey = props.valueKey,
    valueKey = _props$valueKey === void 0 ? 'value' : _props$valueKey,
    _props$childrenKey = props.childrenKey,
    childrenKey = _props$childrenKey === void 0 ? 'children' : _props$childrenKey,
    itemTemplate = props.itemTemplate,
    badgeTemplate = props.badgeTemplate,
    prefixTemplate = props.prefixTemplate,
    suffixTemplate = props.suffixTemplate,
    groupTemplate = props.groupTemplate,
    noResultFound = props.noResultFound,
    _props$maxHeight = props.maxHeight,
    maxHeight = _props$maxHeight === void 0 ? 320 : _props$maxHeight,
    searchWordProp = props.searchWord,
    dropdownItemArialabel = props.dropdownItemArialabel,
    role = props.role,
    searchRef = props.searchRef,
    dropdownRender = props.dropdownRender,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  var containerElementRef = useRef(null);
  var _React$useContext = React.useContext(OptionListContext),
    _React$useContext$dis = _React$useContext.disabledItemValues,
    disabledItemValues = _React$useContext$dis === void 0 ? [] : _React$useContext$dis,
    _React$useContext$fla = _React$useContext.flattenItems,
    flattenItems = _React$useContext$fla === void 0 ? [] : _React$useContext$fla,
    selectedValues = _React$useContext.selectedValues,
    focusItemValue = _React$useContext.focusItemValue,
    onSelect = _React$useContext.onSelect,
    _React$useContext$sea = _React$useContext.searchWord,
    searchWord = _React$useContext$sea === void 0 ? '' : _React$useContext$sea;
  var styles = _extends({}, style);
  var renderSearch = function renderSearch() {
    var onSearchKeyDown = useCallback(function (event) {
      var key = event.key;
      if (KEY_VALUES.DOWN !== key && KEY_VALUES.UP !== key && KEY_VALUES.ESC !== key) {
        event.stopPropagation();
      }
    }, [visible]);
    var handleChange = useCallback(function (value, event) {
      onSearch === null || onSearch === void 0 ? void 0 : onSearch(value, event);
    }, [onSearch]);
    var filterItems = flattenItems.filter(function (item) {
      var _item$data;
      return !(item[valueKey] === 'appkit4-select-all-key' || item.isGroup || (_item$data = item.data) !== null && _item$data !== void 0 && _item$data.disabled);
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, searchable ? /*#__PURE__*/React.createElement("div", {
      className: "search-container"
    }, /*#__PURE__*/React.createElement(Search, {
      style: {
        padding: 0
      },
      placeholder: searchPlaceholder,
      value: searchWord,
      onKeyDown: onSearchKeyDown,
      onChange: handleChange,
      disabled: !visible,
      searchStatus: searchWord && filterItems.length >= 0 ? "There are " + filterItems.length + " items available." : '',
      length: filterItems.length,
      ref: searchRef
    })) : null);
  };
  var handleSelectAll = useCallback(function (value, item, e) {
    // e.preventDefault && e.preventDefault();

    onSelect === null || onSelect === void 0 ? void 0 : onSelect(SELECT_ALL_KEY, [], e);
  }, [onSelect]);
  var handleSelect = useCallback(function (value, item, e) {
    // e.preventDefault && e.preventDefault();

    onSelect === null || onSelect === void 0 ? void 0 : onSelect(value, item, e);
  }, [onSelect]);
  var renderItem = function renderItem(list, _ref) {
    var _item$data2;
    var index = _ref.index,
      style = _ref.style;
    var item = list[index];
    var value = item[valueKey];
    var label = item[labelKey];
    var controlledActive = item === null || item === void 0 ? void 0 : (_item$data2 = item.data) === null || _item$data2 === void 0 ? void 0 : _item$data2.active;
    var isGroup = item.isGroup,
      data = item.data,
      keyProp = item.key;
    var key = data && data.key || keyProp || index;
    if (isGroup) {
      var groupTitle = data[labelKey];
      var groupElement;
      if (groupTemplate && typeof groupTemplate === 'function') {
        groupElement = groupTemplate(label, data);
      }
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "ap-option-group",
        title: getText(groupTitle)
      }, groupElement ? groupElement : /*#__PURE__*/React.createElement("span", {
        className: "ap-group-label"
      }, groupTitle !== undefined ? groupTitle : key));
    }
    var disabled = !data && item.disabled || (data === null || data === void 0 ? void 0 : data.disabled) || (disabledItemValues === null || disabledItemValues === void 0 ? void 0 : disabledItemValues.includes(value));
    var active = Array.isArray(selectedValues) ? selectedValues.includes(value) : selectedValues === value;
    var focus = (focusItemValue === null || focusItemValue === void 0 ? void 0 : focusItemValue.value) === value && (focusItemValue === null || focusItemValue === void 0 ? void 0 : focusItemValue.keyboard);
    var itemElement = null;
    if (itemTemplate && typeof itemTemplate === 'function') {
      itemElement = itemTemplate(label, data);
    }
    return /*#__PURE__*/React.createElement(DropdownMenuItem, {
      className: item[valueKey] === SELECT_ALL_KEY ? 'ap-dropdown-select-all' : '',
      dropdownItemArialabel: dropdownItemArialabel,
      key: index,
      active: typeof controlledActive !== 'undefined' ? controlledActive : item[valueKey] === SELECT_ALL_KEY ? selectedAllChecked : active,
      focus: focus,
      disabled: disabled,
      value: value,
      label: label === SELECT_ALL_KEY ? 'Select all' : label,
      data: data,
      onSelect: handleSelect,
      multiple: multiple,
      highlightWords: searchWord,
      badgeTemplate: badgeTemplate,
      prefixTemplate: prefixTemplate,
      suffixTemplate: suffixTemplate,
      role: role === 'menu' ? 'menuitem' : 'option'
    }, itemTemplate ? itemTemplate(label, data) : null);
  };
  var searchComponent = renderSearch();
  var popupElement = flattenItems.length > 0 ? flattenItems.map(function (_item, index) {
    return renderItem(flattenItems, {
      index: index
    });
  }) : null;
  var popupNode = popupElement;
  if (dropdownRender) {
    popupNode = dropdownRender(popupElement);
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: ClassNames(className, {
      open: visible,
      hide: !visible
    }),
    style: styles,
    ref: mergeRefs(ref, containerElementRef),
    role: role,
    "aria-multiselectable": multiple,
    "aria-labelledby": "combo1-label"
  }, restProps), searchComponent, flattenItems.length === 0 ? /*#__PURE__*/React.createElement("div", {
    key: "noResult",
    className: "ap-option-item noResult"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ap-option-label"
  }, noResultFound)) : popupNode);
});
DropdownMenu.displayName = 'DropdownMenu';
export default DropdownMenu;